import { get } from 'lodash';

export const selectMessages = state => get(state, ['Messages'], []);
